// extracted by mini-css-extract-plugin
module.exports = {"root":"ShutdownsTable_root__21VP8","paginationWrap":"ShutdownsTable_paginationWrap__QA9TS"};